enum LimitUnit {
  MIN = 1,
  HOUR = 2,
  DAY = 3,
  MONTH = 4,
  YEAR = 5,
}

export default LimitUnit
